import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@redngapps/feature-flags/env/types';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.featureSwitches.angularProdModeEnabled) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
